import React, { useState, useEffect, useRef } from 'react';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef();

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuOpen && navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="header-container">

        {/* Logo (desktop uses default, mobile swaps via <picture>) */}
        <div className="logo">
          <a href="#home" aria-label="Go to Home">
            <picture>
              {/* MOBILE logo (shows at <=768px). Replace srcSet with your mobile logo path */}
              <source media="(max-width: 768px)" srcSet="/Media/Logo/LogoMobile.png" />
              {/* DESKTOP / default logo */}
              <img src="/Media/Logo/Logo.png" alt="Yog Yatra Logo" />
            </picture>
          </a>
        </div>

        {/* Hamburger placed as a sibling so it can sit to the right of the centered logo on mobile */}
        <button
          className="hamburger"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>

        {/* Right side: social + nav (desktop layout unchanged) */}
        <div className="right">
          <div className="social">
            <a href="http://wa.me/919999345631" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/whatsapp.gif" alt="WhatsApp" />
            </a>
            <a href="https://www.youtube.com/@yogyatrainstitute" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/youtube.png" alt="YouTube" />
            </a>
            <a href="https://www.instagram.com/yog_yatra_institute" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.facebook.com/p/Yog-Yatra-Institute-61556969956078/" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/facebook.png" alt="Facebook" />
            </a>
          </div>

          <nav className={`nav ${menuOpen ? 'open' : ''}`} ref={navRef}>
            <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="#about" onClick={() => setMenuOpen(false)}>About Us</a>
            <a href="#sessions" onClick={() => setMenuOpen(false)}>Sessions & Timing</a>
            <a href="#courses" onClick={() => setMenuOpen(false)}>Courses</a>
            <a href="#gallery" onClick={() => setMenuOpen(false)}>Gallery</a>
            <a href="#contact" onClick={() => setMenuOpen(false)}>Contact Us</a>
            <a href="#testimonials" onClick={() => setMenuOpen(false)}>Testimonials</a>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
